<template>
  <div class="carouselDiv" :style="carouselForm.style">
    <el-carousel ref="carousel" :direction="carouselForm.direction" :autoplay="carouselForm.autoplay" :indicator-position="carouselForm.indicatorPosition" :type="carouselForm.type">
      <el-carousel-item v-for="item in list" :key="item.picture">
        <el-image :src="item.picture" style="width: 100%; height: 100%"></el-image>
      </el-carousel-item>
    </el-carousel>

    <ul class="position-item">
      <li @mouseenter="handleChange(index)" :style="{color:carouselIndex == index ? '#fc5e5e' : '#ffffff99'}" v-for="(item,index) in list" :key="item.id"><i v-if="carouselIndex == index" class="iconfont icon-fangxiang-you"></i>{{item.title}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: { editForm: Object, list: Array },
  data () {
    return {
      carouselForm: {},
      carouselIndex: 0,
    };
  },
  watch: {
    editForm: {
      handler: function (val) {
        this.initData(val);
      },
      deep: true,
    },
  },

  methods: {
    initData (val) {
      this.carouselForm = this.objectAssign(val);
    },
    objectAssign (obj) {
      if (!obj) return false
      console.log('***************', obj)
      let jsonObj = JSON.parse(obj.styleJson);
      return Object.assign({}, obj, jsonObj);
    },

    handleChange (i) {
      this.carouselIndex = i
      this.$refs.carousel.setActiveItem(i)
    },
  },
  mounted () {
    this.initData(this.editForm);
    console.log(this.editForm, this.list, 343343);
  },
};
</script>
<style lang="less" scoped>
.el-carousel {
  height: 100%;
}
.carouselDiv {
  position: relative;
}
.carouselDiv /deep/ .el-carousel__container {
  height: 100%;
}

.position-item {
  @media screen and (min-width: 1300px) {
    padding: 10px 5%;
  }
  @media screen and (min-width: 1400px) {
    padding: 10px 10%;
  }
  @media screen and (min-width: 1700px) {
    padding: 10px 14.5%;
  }
  @media screen and (min-width: 1820px) {
    padding: 10px 18.5%;
  }
  position: absolute;
  display: flex;
  justify-content: space-around;
  bottom: 0;
  left: 50%;
  width: 100%;
  transform: translate(-50%, 0);
  background-color: rgba(0, 0, 0, 0.3);
  // width: 282px;
  // background-color: #fff;

  z-index: 2;
  li {
    margin: 0 10px;
    font-family: "Arial Normal", "Arial";
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    i {
      margin-right: 5px;
      font-size: 12px;
    }
  }
  // @media screen and (min-width: 1600px) {
  //   left: 10%;
  // }
  // @media screen and (min-width: 1920px) {
  //   left: 18.5%;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/template/carousel.vue